import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NEVER, Observable, catchError, throwError } from "rxjs";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router:Router) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler) : Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((errorResponse:HttpErrorResponse) => {
                if (errorResponse.status === HttpStatusCode.Unauthorized || errorResponse.status === HttpStatusCode.Forbidden) {
                    this.router.navigate(['/login']);
                    return NEVER;
                }
                return throwError(()=>errorResponse);
            })
        );
    }

}